// @flow
import React from "react";
import MagnifyingGlassIconSvg from "../../../svg/magnifyingGlassIcon.svg";

import styles from "./magnifyingGlassIcon.module.scss";

type Props = {
  className?: string
};
const MagnifyingGlassIcon = ({ className = "" }: Props) => {
  return <MagnifyingGlassIconSvg className={`${styles.base} ${className}`} />;
};

export default MagnifyingGlassIcon;
